import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  library: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 8,
    padding: 0
  }
})

export default useStyles
